import { customElement } from 'lit/decorators.js';
import { style } from './service-navigation.styles';
import {html, LitElement} from 'lit';


@customElement('sbk-service-navigation')
export class SbkServiceNavigation extends LitElement {

    static get styles() {
        return style;
    }

    render() {
        return html`
            <ul>
                <slot></slot>
            </ul>
        `;
    }
}
